import { collection } from "firebase/firestore";
import { db } from "./firebase";

const dbref = collection(db, "Posts");
export default dbref;
